require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-reason-webpack-plugin.json") })
        }
      }, "path---package-reason-webpack-plugin");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-reason-webpack-plugin!./.cache/json/package-reason-webpack-plugin.json
// module id = 908
// module chunks = 231608221292675